import React from "react";
import { Input } from "reactstrap";
import { InputType } from "reactstrap/lib/Input";

interface Props {
  input: {
    name: string;
    type: string;
    value: string;
    checked: boolean;
    onChange: () => void;
  };
  id: string;
  label?: string;
  disabled?: boolean;
}

const CheckboxInputCustom: React.FC<Props> = ({
  input,
  id,
  label,
  disabled,
}) => {
  return (
    <div className="custom-control custom-checkbox myCustom-control">
      <Input
        {...input}
        id={id}
        className="custom-control-input"
        type={input.type as InputType}
        disabled={disabled}
      />
      <label className="custom-control-label text-nowrap" htmlFor={id}>
        {label ?? id}
      </label>
    </div>
  );
};

export default CheckboxInputCustom;
